<template>
  <component :is="type" :href="href" class="button" @click="onClickFunction">
    {{label_button}}
    <slot />
  </component>
</template>

<script>
  export default {
    name: "input-button",
    props: {
      href: {
        type: String,
        default: null
      },
      to: {
        type: String,
        default: null
      },
      label_button: {
        type: String,
        default: "Button",
      },
      onClick: {
        type: Function,
        default: () => null
      }
    },
    computed: {
      type() {
        if (this.href) {
          return 'a'
        } else {
          return 'button'
        }
      },
    },
    methods: {
      onClickFunction() {
        this.onClick();
      }
    }
  }
</script>

<style scoped lang="scss">
  .button {
    outline: 0;
    border-color: #9999;
    margin: 0.5em 0;
    background: #fff;
    border-radius: 5px;
    color: #000;
    font-family: "Quicksand", sans-serif;
    font-size: 1em;
    font-weight: 700;
    letter-spacing: 0.02em;
    cursor: pointer;
    transition: 0.3s;
    padding: 0px 15px 23px 14px;
    height: 16px;
    white-space: normal;

    &:hover {
      background: #ec9148;
      color: #fff;
    }
  }
</style>